import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useMeta } from "../lib/seo";

export default function NewsletterArchive() {
  useMeta("Newsletter archive - past denial-fighting guides | Denial Decoder", "Past issues of the Denial Decoder newsletter — claim process tips, coverage guides, and contract fine print.");
  const [issues, setIssues] = useState([]);
  useEffect(() => { api.get("/newsletter/archive").then((r) => setIssues(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 py-16 fade-in" data-testid="newsletter-archive-page">
      <h1 className="text-4xl font-extrabold tracking-tight mb-2">Newsletter archive</h1>
      <p className="text-slate-600 mb-10">Every issue we&rsquo;ve sent — the full articles live on the blog.</p>
      {issues.length === 0 && <p className="text-slate-500">No issues yet. Subscribe in the footer to get the first one.</p>}
      <div className="space-y-4">
        {issues.map((i) => (
          <Link key={i.id} to={`/blog/${i.slug}`} className="block bg-white border border-slate-200 rounded-2xl p-5 hover:shadow-md transition-shadow" data-testid={`archive-issue-${i.slug}`}>
            {i.category && <span className="text-xs font-bold bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-full">{i.category}</span>}
            <p className="text-xs text-slate-500 mt-2">{new Date(i.published_at || i.sent_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>
            <h2 className="text-lg font-semibold mt-1">{i.title || i.subject}</h2>
            {i.preview_text && <p className="text-sm text-slate-500 mt-1">{i.preview_text}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
}
